import { html, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import DERModuleElement from '~/modules/utils/der-module-element';
import '~/ui/components/tag';
import '~/ui/components/button';
import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './quote-card.styles';
import { classMap } from 'lit/directives/class-map.js';
import { Quote } from '../types';
import { SvgUtility } from '~/ui/utils';

export class QuoteCard extends DERModuleElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    @property({ type: Number }) index!: number;

    @property({ type: Number }) length!: number;

    @property({ type: Object }) quote!: Quote;

    renderQuote() {
        const isTopQuote = this.index % 4 === 0;
        const isBottomQuote = this.index % 4 === 2;

        if (isTopQuote) {
            return html`<div class="c-quoteCard__quote-top">
                <svg xmlns="http://www.w3.org/2000/svg" width="65" height="48" viewBox="0 0 65 48" fill="none">
                    ${SvgUtility.systemQuoteTop}
                </svg>
            </div>`;
        }

        if (isBottomQuote) {
            return html`<div class="c-quoteCard__quote-bottom">
                <svg xmlns="http://www.w3.org/2000/svg" width="65" height="48" viewBox="0 0 65 48" fill="none">
                    ${SvgUtility.systemQuoteBottom}
                </svg>
            </div>`;
        }

        return html``;
    }

    override render() {
        const quote = this.quote;
        return html`
            <div class="c-quoteCard">
                ${this.renderQuote()}
                <div class="c-quoteCard__container">
                    <div class="c-quoteCard__tip-container">
                        <div class="c-quoteCard__title">${quote.tip.title}</div>
                        <div class="c-quoteCard__text">${quote.tip.text}</div>
                    </div>
                    <div class="c-quoteCard__expert-container">
                        <div
                            class=${classMap({
                                'c-quoteCard__image': quote.expert.image,
                                'c-quoteCard__image__no-image': !quote.expert.image,
                            })}
                            style="background-image: url('${quote.expert.image}')"
                        ></div>
                        <div class="c-quoteCard__expert-info-container">
                            <div class="c-quoteCard__name">${quote.expert.name}</div>
                            <div class="c-quoteCard__metainfo">${quote.expert.jobTitle}</div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
